/*** IMPORTS FROM imports-loader ***/
var define = false;

export default { type: 'email', message: 'Please enter a valid email address.' }

